import { createSelector } from 'reselect';

import { normalizeWallpaper } from '@wetransfer/transfer/component/TransferCustomizationProvider/utils';
import { AppConfig } from '@wetransfer/transfer/core-bundle/config/app-config';
import { CuratedWallPaper } from '@wetransfer/transfer/store/action/helper/image';
import { selectAccountWallpapers } from '@wetransfer/transfer/store/selector/account';

export const selectNormalizedWallpapers = createSelector(
  selectAccountWallpapers,
  (brandedWallpapers) => {
    return [
      ...brandedWallpapers,
      ...(AppConfig.curatedWallpapers as CuratedWallPaper[]),
    ].map(normalizeWallpaper);
  }
);
